export default __webpack_public_path__ + "static/media/side_rooms_white.0156a208.svg";